import { useMemo, useState, useRef } from 'react'
import Lottie from 'react-lottie'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import watsonAssistant from '../../../utils/watson-assistant'
import * as animationData from '../../../assets/animations/hotspot.json'
import './styles.scss'
import { useVehicleContext } from '../../../hooks/useVehicleContext'
import { data } from '../../../data'

const Safety = () => {
  const { t } = useTranslation()
  const containerRef = useRef(null)
  const { vehicleType } = useVehicleContext()
  const tabs = data[vehicleType]?.safetyTabs || []
  const [activeTab, setActiveTab] = useState(tabs[0].label)

  const activeTabObj = useMemo(() => tabs.find((tab) => tab.label === activeTab), [tabs, activeTab])

  return (
    <div className="Blueprint-safety">
      <p className="Blueprint-safety__Question">{t('blueprint.safety.question')}</p>
      <div
        className={classNames({
          'Blueprint-safety__YamahaTabs': true,
          'Blueprint-safety__YamahaTabs__column': tabs.length > 2,
        })}
      >
        {tabs.map((tab, idx) => (
          <button
            key={idx}
            className={classNames({
              'yamaha-btn': true,
              'yamaha-btn--active': activeTab === tab.label,
            })}
            onClick={() => setActiveTab(tab.label)}
            disabled={activeTab === tab.label}
          >
            {t(tab.label)}
          </button>
        ))}
      </div>

      <div
        className="Blueprint-safety__Container"
        ref={containerRef}
      >
        <div className="Blueprint-safety__Description">
          <p className="uppercase">{t('blueprint.safety.includedIn')}</p>
          <p>{t('blueprint.safety.allTrims')}</p>
        </div>
        <div className="Blueprint-safety__ImageContainer">
          <img
            className="Blueprint-safety__Background"
            src={activeTabObj.image}
            alt="Blueprint airbags"
          />
          {activeTabObj.dots.map((dot, index) => (
            <div
              key={index}
              className={classNames({
                Blueprint__DotContainer: true,
                [`Blueprint-safety__position-${dot.position}`]: true,
              })}
              style={{ top: `${dot.top}%`, left: `${dot.left}%` }}
              onClick={() => {
                watsonAssistant.getInstance().sendMessageHotspot(t(dot.message))
              }}
            >
              <div className="Blueprint-safety__Label">{t(dot.label)}</div>
              <div
                className={classNames({
                  Blueprint__LottieDot: true,
                  [`Blueprint-safety__dot-position-${dot.position}`]: true,
                })}
              >
                <Lottie
                  isClickToPauseDisabled
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: animationData,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Safety
